import type { FlagConfiguration } from '@atlassian/jira-flags';
import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	title: {
		id: 'copy-filters-modal.common.flags.error.title',
		defaultMessage: "We couldn't copy a filter",
		description:
			'Title of the flag shown in Filters Directory when the request for creating a copy of the existing filter failed',
	},
	description: {
		id: 'copy-filters-modal.common.flags.error.description',
		defaultMessage: 'There was an error, please try again.',
		description:
			'Message shown in the flag displayed in Filters Directory when the request for creating a copy of the existing filter failed',
	},
});

const copyFilterErrorFlag = (): FlagConfiguration => ({
	type: 'error',
	title: messages.title,
	description: messages.description,
	messageId: 'copy-filters-modal.common.ui.flags.error',
	messageType: 'transactional',
});

export default copyFilterErrorFlag;
